import * as React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { EditState, IQuestionChange, ISurveyQuestionEditModel } from '../../../models';
import { QuestionChangeType } from '../../../models/IQuestionChange';
import { connect } from 'react-redux';
import { IApplicationState } from '../../../store';

export const QuestionTextUpdate = styled.p``;
export const QuestionTranslationAdded = styled.p``;
export const QuestionTranslationDeleted = styled.p``;
export const QuestionTranslationUpdated = styled.p``;
export const ResponseOptionGroup = styled.div``;
ResponseOptionGroup.displayName = 'ResponseOptionGroup';
export const ResponseOptions = styled.div`
	& > div {
		margin-left: 20px;
	}
`;
export const ResponseOptionTranslationAdded = styled.p``;
export const ResponseOptionTranslationDeleted = styled.p``;
export const ResponseOptionTranslationUpdated = styled.p``;

export interface IQuestionChangesModalContentProps {
	defaultCultureCode: string;
	question: ISurveyQuestionEditModel;
	questionChange: IQuestionChange;
}

export class QuestionChangesModalContent extends React.PureComponent<IQuestionChangesModalContentProps> {
	constructor(props: IQuestionChangesModalContentProps) {
		super(props);
	}

	public render() {
		const { defaultCultureCode, questionChange } = this.props;

		const changes = questionChange ? questionChange.changes : [];
		const questionDefaultTranslationsUpdated = _.filter(
			changes,
			(c) =>
				c.changeType === QuestionChangeType.QuestionTranslation && c.editState === EditState.Update && c.cultureCode === defaultCultureCode,
		);
		const questionTranslationsAdded = _.filter(
			changes,
			(c) =>
				c.changeType === QuestionChangeType.QuestionTranslation && c.editState === EditState.Add && c.cultureCode !== defaultCultureCode,
		);
		const questionTranslationsDeleted = _.filter(
			changes,
			(c) =>
				c.changeType === QuestionChangeType.QuestionTranslation && c.editState === EditState.Remove && c.cultureCode !== defaultCultureCode,
		);
		const questionTranslationsUpdated = _.filter(
			changes,
			(c) =>
				c.changeType === QuestionChangeType.QuestionTranslation && c.editState === EditState.Update && c.cultureCode !== defaultCultureCode,
		);
		return (
			<>
				{questionChange && (
					<>
						{questionDefaultTranslationsUpdated && questionDefaultTranslationsUpdated.length > 0 && (
							<QuestionTextUpdate>
								- {ContentConstants.QUESTION_CHANGES_TEXT_CHANGED.replace('{text}', questionDefaultTranslationsUpdated[0].text)}
							</QuestionTextUpdate>
						)}
						{questionTranslationsAdded && questionTranslationsAdded.length > 0 && (
							<QuestionTranslationAdded>
								-{' '}
								{ContentConstants.QUESTION_CHANGES_QUESTION_TRANSLATIONS_ADDED.replace(
									'{translations}',
									questionTranslationsAdded.map((t) => t.cultureName).join(', '),
								)}
							</QuestionTranslationAdded>
						)}
						{questionTranslationsDeleted && questionTranslationsDeleted.length > 0 && (
							<QuestionTranslationDeleted>
								-{' '}
								{ContentConstants.QUESTION_CHANGES_QUESTION_TRANSLATIONS_DELETED.replace(
									'{translations}',
									questionTranslationsDeleted.map((t) => t.cultureName).join(', '),
								)}
							</QuestionTranslationDeleted>
						)}
						{questionTranslationsUpdated && questionTranslationsUpdated.length > 0 && (
							<QuestionTranslationUpdated>
								-{' '}
								{ContentConstants.QUESTION_CHANGES_QUESTION_TRANSLATIONS_UPDATED.replace(
									'{translations}',
									questionTranslationsUpdated.map((t) => t.cultureName).join(', '),
								)}
							</QuestionTranslationUpdated>
						)}
						{this.RenderResponseOptionGroup()}
						{this.RenderResponseOptions()}
						{this.RenderResponseOptionTranslations()}
					</>
				)}
			</>
		);
	}

	private RenderResponseOptionGroup = () => {
		const { question, questionChange } = this.props;
		const changes = questionChange ? questionChange.changes : [];
		const followUpChanges = _.filter(
			changes,
			(c) =>
				c.changeType === QuestionChangeType.ResponseOptionGroup &&
				c.editState === EditState.Update &&
				c.text.toLocaleLowerCase().includes('follow up'),
		);
		return (
			<>
				{!_.isEqual(question.responseOptionGroup, questionChange.question.responseOptionGroup) && (
					<ResponseOptionGroup>
						- {`${ContentConstants.QUESTION_CHANGES_RESPONSE_OPTION_GROUP}${questionChange.question.responseOptionGroup}`}
					</ResponseOptionGroup>
				)}
				{followUpChanges && followUpChanges.length > 0 && (
					<ResponseOptionGroup>{ContentConstants.QUESTION_CHANGES_FOLLOW_UP}</ResponseOptionGroup>
				)}
			</>
		);
	};
	private RenderResponseOptions = () => {
		const { question, questionChange } = this.props;
		return (
			<>
				{!_.isEqual(question.responseOptions, questionChange.question.responseOptions) &&
					questionChange.question.responseOptionGroup !== ContentConstants.RESPONSE_OPTION_GROUP_OPEN_ENDED && (
						<ResponseOptions>
							- {ContentConstants.QUESTION_CHANGES_RESPONSE_OPTIONS}
							{questionChange.question.responseOptions?.map((ro, index) => {
								return <div key={`response-option-${index}`}>* {ro}</div>;
							})}
						</ResponseOptions>
					)}
			</>
		);
	};
	private RenderResponseOptionTranslations = () => {
		const { questionChange } = this.props;
		const changes = questionChange ? questionChange.changes : [];
		const responseOptionTranslationsAdded = _.filter(
			changes,
			(c) => c.changeType === QuestionChangeType.ResponseOptionTranslation && c.editState === EditState.Add,
		);
		const responseOptionTranslationsDeleted = _.filter(
			changes,
			(c) => c.changeType === QuestionChangeType.ResponseOptionTranslation && c.editState === EditState.Remove,
		);
		const responseOptionTranslationsUpdated = _.filter(
			changes,
			(c) => c.changeType === QuestionChangeType.ResponseOptionTranslation && c.editState === EditState.Update,
		);
		return (
			<>
				{responseOptionTranslationsAdded && responseOptionTranslationsAdded.length > 0 && (
					<ResponseOptionTranslationAdded>
						{ContentConstants.QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_ADDED.replace(
							'{translations}',
							responseOptionTranslationsAdded.map((t) => t.cultureName).join(', '),
						)}
					</ResponseOptionTranslationAdded>
				)}
				{responseOptionTranslationsDeleted && responseOptionTranslationsDeleted.length > 0 && (
					<ResponseOptionTranslationDeleted>
						{ContentConstants.QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_DELETED.replace(
							'{translations}',
							responseOptionTranslationsDeleted.map((t) => t.cultureName).join(', '),
						)}
					</ResponseOptionTranslationDeleted>
				)}
				{responseOptionTranslationsUpdated && responseOptionTranslationsUpdated.length > 0 && (
					<ResponseOptionTranslationUpdated>
						{ContentConstants.QUESTION_CHANGES_RESPONSE_OPTION_TRANSLATIONS_UPDATED.replace(
							'{translations}',
							responseOptionTranslationsUpdated.map((t) => t.cultureName).join(', '),
						)}
					</ResponseOptionTranslationUpdated>
				)}
			</>
		);
	};
}

export const QuestionChangesModalContentContainer: React.ComponentType<any> = connect((state: IApplicationState) => {
	return { defaultCultureCode: state.survey.surveyEditModel.defaultCultureCode };
})(QuestionChangesModalContent);
